import { render, staticRenderFns } from "./btn-minor.vue?vue&type=template&id=7101f0ec"
import script from "./btn-minor.vue?vue&type=script&lang=js"
export * from "./btn-minor.vue?vue&type=script&lang=js"
import style0 from "./btn-minor.vue?vue&type=style&index=0&id=7101f0ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports